import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { allMomentsQuery } from '../moment/withMomentDays'

const deleteMomentMutation = gql`
  mutation DeleteMoment($id: ID!) {
    deleteMoment(id: $id) {
      id
    }
  }
`

function updateCacheOnDeleted(userId) {
  return (cache, { data: { deleteMoment } }) => {
    const { allMoments } = cache.readQuery({
      query: allMomentsQuery,
      variables: { userId },
    })

    cache.writeQuery({
      query: allMomentsQuery,
      variables: { userId },
      data: {
        allMoments: allMoments.filter(moment => moment.id !== deleteMoment.id),
      },
    })
  }
}

const DeleteMomentAction = ({ children, id, userId }) => (
  <Mutation
    mutation={deleteMomentMutation}
    update={updateCacheOnDeleted(userId)}
    optimisticResponse={{
      __typename: 'Mutation',
      deleteMoment: { id, __typename: 'Moment' },
    }}
  >
    {deleteMoment => children(() => deleteMoment({ variables: { id } }))}
  </Mutation>
)

export default DeleteMomentAction



// WEBPACK FOOTER //
// ./src/components/templates/deleteMoment/DeleteMomentAction.js